module.exports = __webpack_public_path__ + "40b0d532.jpg";